import { ObjectsFactory, Model, IPaginateResponse } from './core'
import { IUser } from '.'

export enum Activities {
  User = 'user',
  Company = 'companies'
}

export enum StatusLogsEnum {
  Information = 'information',
  Warning = 'warning',
  Error = 'error',
  Success = 'success'
}
export interface IActivity {
  id: number
  email: string
  firstName: string
  lastName: string
  address: string
  phone: number
  status: string
  createdAt: string
  action: string
  data: {
    description: string
    data: any
    params: {
      id: string
      period: string
      amount: string
      paymentTerm: string
      attachment: string
      contractId: string
      status: string
      createdAt: string
      updatedAt: string
      typeBondSecuring: string
      isCreditManagement: 0 | 1
      checkCredit: string
      creditDate: string
      collateralAmount: string
      setCollateralAmount: string
    }
  }
  causer: IUser
}

const modelConfig = {
  path: '/activity',
  model: 'ACTIVITY'
}

export enum ActivityLogTypeEnum {
  User = 'user',
  Company = 'employer',
  Finance = 'finance',
  Transaction = 'transaction',
  Attendance = 'attendance',
  SettingFinance = 'setting_finance'
}

export class Activity extends Model {
  static queryKeys = {
    findAll: 'ACTIVITY_QUERY',
    findOne: 'ACTIVITY_FIND_ONE_QUERY'
  }

  static objects = ObjectsFactory.factory<IActivity>(modelConfig, this.queryKeys)

  static getActivityLogs = (params: any) => {
    return {
      queryKey: [this.queryKeys.findAll, params],
      queryFn: () => {
        return this.api
          .get<IPaginateResponse<any>>({
            url: `/activity`,
            params
          })
          .then(r => r.data)
      }
    }
  }
}

Activity.setup(modelConfig)
